import { ResponseType } from "@shared/services/partners/partnerSubscriptions/response.ts";
import { OriginalResponse } from "@shared/services/partners/EntitlementPerSubscriptionUsage/response.ts";
import myJFrogUtils from "@shared/utils/myJFrogUtils.ts";

export const calcPercentage = (
  subscription: ResponseType["subscriptions"][0],
  usageSubscriptions: OriginalResponse["subscriptions"],
) => {
  const usageForSubscription = usageSubscriptions.filter(
    (value) => value.subscriptionNumber === subscription.subscriptionId,
  );

  if (usageForSubscription.length === 0) {
    // returning -1 to indicate that the usage for this subscription is not available
    return -1;
  }
  // sums all usage Datatransfer and Storage
  const sumOfCurrentUsage = usageForSubscription.reduce(
    (sum, item) => sum + item.value,
    0,
  );

  return myJFrogUtils.calculatePercentage(
    sumOfCurrentUsage,
    subscription.consumptionThresholdBytes, // total of subscription usage
  );
};
